import { ChatSettingsRoute } from '@pwa/components/chat/chat-settings-route';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/org/$orgId/c/$chatId/settings')({
	component: OrgChatSettingsRoute,
	validateSearch: (_search: Record<string, unknown>) => ({}),
});

function OrgChatSettingsRoute() {
	const { chatId, orgId } = Route.useParams();
	return <ChatSettingsRoute chatId={chatId} orgId={orgId} />;
}
